// extracted by mini-css-extract-plugin
export default {"container":"index-module--container--UJTa0","checkmark":"index-module--checkmark--Niph7"};